import type { ShipmentState } from 'graphql-models';
import { randomId, type Factory } from 'walden-fast/types/mocks';

const MOCK_SHIPMENT_STATE: ShipmentState = {
  id: '23839274928',
  changedAt: new Date('Mon Mar 21 2025 15:15:35 GMT+0100').toISOString(),
  estimatedArrivalTime: new Date(
    'Mon Mar 21 2025 15:15:35 GMT+0100',
  ).toISOString(),
  state: 'ARRIVING',
};

export const shipmentStateFactory: Factory<ShipmentState> = (overrides) => ({
  ...MOCK_SHIPMENT_STATE,
  id: randomId(),
  ...overrides,
});
